// extracted by mini-css-extract-plugin
export default {"container":"iR-z","dimension":"jR-z","dimensionLabels":"kR-z"};